const events = [
  {
    id: 1,
    name: "FIRST DAY",
    date: "22 NOV 2022",
    timeManage: [
      {
        serial: 1,
        time: "09:00 - 11:00",
        title: "Registration",
        desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore odit neque hic sapiente ab soluta, maxime, beatae ipsum cum eligendi reprehenderit non numquam culpa nam!",
      },
      {
        serial: 2,
        time: "11:00 - 12:00",
        title: "Introduction",
        desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore odit neque hic sapiente ab soluta, maxime, beatae ipsum cum eligendi reprehenderit non numquam culpa nam!",
      },
      {
        serial: 3,
        time: "12:00 - 14:00",
        title: "Speaker Speech",
        desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore odit neque hic sapiente ab soluta, maxime, beatae ipsum cum eligendi reprehenderit non numquam culpa nam!",
      },
      {
        serial: 4,
        time: "14:00 - 15:00",
        title: "Launch",
        desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore odit neque hic sapiente ab soluta, maxime, beatae ipsum cum eligendi reprehenderit non numquam culpa nam!",
      },
      {
        serial: 5,
        time: "15:00 - 16:00",
        title: "Final Speech",
        desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore odit neque hic sapiente ab soluta, maxime, beatae ipsum cum eligendi reprehenderit non numquam culpa nam!",
      },
    ],
  },
  {
    id: 2,
    name: "SECOND DAY",
    date: "23 NOV 2022",
    timeManage: [
      {
        serial: 1,
        time: "10:00 - 11:00",
        title: "Registration",
        desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore odit neque hic sapiente ab soluta, maxime, beatae ipsum cum eligendi reprehenderit non numquam culpa nam!",
      },
      {
        serial: 2,
        time: "11:00 - 12:00",
        title: "Introduction",
        desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore odit neque hic sapiente ab soluta, maxime, beatae ipsum cum eligendi reprehenderit non numquam culpa nam!",
      },
      {
        serial: 3,
        time: "12:00 - 13:00",
        title: "Speaker Speech",
        desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore odit neque hic sapiente ab soluta, maxime, beatae ipsum cum eligendi reprehenderit non numquam culpa nam!",
      },
      {
        serial: 4,
        time: "13:00 - 14:00",
        title: "Launch",
        desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore odit neque hic sapiente ab soluta, maxime, beatae ipsum cum eligendi reprehenderit non numquam culpa nam!",
      },
      {
        serial: 5,
        time: "14:00 - 16:00",
        title: "Final Speech",
        desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore odit neque hic sapiente ab soluta, maxime, beatae ipsum cum eligendi reprehenderit non numquam culpa nam!",
      },
    ],
  },
  {
    id: 3,
    name: "THIRD DAY",
    date: "24 NOV 2022",
    timeManage: [
      {
        serial: 1,
        time: "09:00 - 11:00",
        title: "Registration",
        desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore odit neque hic sapiente ab soluta, maxime, beatae ipsum cum eligendi reprehenderit non numquam culpa nam!",
      },
      {
        serial: 2,
        time: "11:00 - 12:00",
        title: "Introduction",
        desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore odit neque hic sapiente ab soluta, maxime, beatae ipsum cum eligendi reprehenderit non numquam culpa nam!",
      },
      {
        serial: 3,
        time: "12:00 - 14:00",
        title: "Speaker Speech",
        desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore odit neque hic sapiente ab soluta, maxime, beatae ipsum cum eligendi reprehenderit non numquam culpa nam!",
      },
      {
        serial: 4,
        time: "14:00 - 15:00",
        title: "Launch",
        desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore odit neque hic sapiente ab soluta, maxime, beatae ipsum cum eligendi reprehenderit non numquam culpa nam!",
      },
      {
        serial: 5,
        time: "15:00 - 16:00",
        title: "Final Speech",
        desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore odit neque hic sapiente ab soluta, maxime, beatae ipsum cum eligendi reprehenderit non numquam culpa nam!",
      },
    ],
  },
];

export default events;
